<template>
  <div id="parceiros">
    <h1 class="title text-uppercase font-weight-bold">Ranking Parceiros</h1>
    <hr />
    <h6 class="subtitle text-uppercase">
      <b>Campanha</b> - {{ from }} a {{ to }}
    </h6>
    <h6 class="subtitle text-uppercase">
      <b>Total de Lojistas</b> - {{ shopkeepers }}
    </h6>
    <hr class="linha-amarela" />
    <div v-if="check_adm()">
      <label
        >Escolha uma data. Os usuários verão a ordem do ranking nesta
        data:</label
      >
      <br />
      <SelectDates :tfrom="true" @filter_ranking="filter_ranking($event)" />
      <hr class="linha-amarela" />
    </div>
    <div v-if="this.partners.length >= 1" class="limit-table">
      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th>Posição</th>
            <th>Parceiro</th>
            <th>Nº Lojistas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(parceiro, index) in partners" :key="parceiro.id">
            <td v-if="index + 1 == 1">
              {{ index + 1 }}º Lugar
              <span style="color: gold">
                <i class="fas fa-trophy"></i>
              </span>
            </td>
            <td v-else-if="index + 1 == 2">
              {{ index + 1 }}º Lugar
              <span style="color: silver">
                <i class="fas fa-trophy"></i>
              </span>
            </td>
            <td v-else-if="index + 1 == 3">
              {{ index + 1 }}º Lugar
              <span style="color: orange">
                <i class="fas fa-trophy"></i>
              </span>
            </td>
            <td v-else>{{ index + 1 }}º Lugar</td>
            <td v-if="parceiro.nome !== null">{{ parceiro.nome }}</td>
            <td v-else>Sem Nome</td>
            <td v-if="parceiro.quantidade_lojistas > 0">
              {{ parceiro.quantidade_lojistas }}
            </td>
            <td v-else>Sem lojistas</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-white">
      <center style="background: red">
        <i class="fas fa-times"></i> Nenhum parceiro ainda neste ranking!
      </center>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';
import SelectDates from '../../components/Menu/SelectDates.vue';

export default {
  name: 'parceiros',
  mixins: [makeToast],
  components: {
    SelectDates,
  },
  data() {
    return {
      partners: [],
    };
  },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('partner', ['setPartners']),
  },
  created() {
    this.ranking()
      .then((response) => {
        this.partners = response.data.data;
        this.shopkeepers = response.data.shopkeepers;
        this.from = response.data.from;
        this.to = response.data.to;
      })
      .catch((error) => {
        console.log(error);
        this.makeToast(
          'Oopss!',
          'Não foi possivel carregar o ranking!',
          'danger'
        );
      });
  },
  methods: {
    ...mapActions('partner', ['getAll', 'ranking']),
    ...mapActions('admin', ['setRankingDate']),
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    filter_ranking(ranking_range) {
      this.setRankingDate(ranking_range)
        .then(() => {
          this.ranking()
            .then((response) => {
              this.partners = response.data.data;
              this.shopkeepers = response.data.shopkeepers;
              this.from = response.data.from;
              this.to = response.data.to;
            })
            .catch((error) => {
              console.log(error);
              this.makeToast(
                'Oopss!',
                'Não foi possivel carregar o ranking!',
                'danger'
              );
            });
        })
        .catch((error) => {
          console.log(error);
          this.makeToast(
            'Oopss!',
            'Não foi possivel atualizar o ranking!',
            'danger'
          );
        });
    },
    check_adm() {
      return this.dadosUsuario.tipo_usuario_id == 5;
    },
  },
};
</script>
